import $ from 'jquery';

export const addCookieManager = () => {
  $(function () {
    $('<div id="consent_blackbar" />').insertBefore('body');
    var a = document.createElement('script');
    a.setAttribute('src', process.env.REACT_APP_URL_SCRIPT_COOKIES || 'NO URL');
    document.head.appendChild(a);
    $('.copyright-text').find('p:eq(0)').append('<div id="teconsent"></div>');
  });
};
